<template>
  <div class="mt-6 container has-text-centered">
    <div class="column is-4 is-offset-4">
      <img src="/img/logo.svg" />
      <hr class="login-hr" />
      <p class="subtitle has-text-black">{{ $t("auth.forgotTitle") }}</p>
      <div class="notification is-info is-light has-text-left">
        {{ $t("auth.forgotMessage") }}
      </div>

      <div class="box">
        <form @submit.prevent="forgotPassword">
          <div class="field">
            <div class="control">
              <input
                class="input is-large"
                type="email"
                placeholder="Your Email"
                required
                autofocus=""
                v-model="form.email"
              />
            </div>
          </div>

          <button
            class="button is-block is-primary is-large is-fullwidth"
            v-bind:class="{ 'is-loading': isLoad }"
          >
            {{ $t("auth.forgotSubmit") }}
          </button>
        </form>
      </div>
      <div
        v-if="errorMessage"
        class="notification is-danger is-light has-text-left"
      >
        {{ errorMessage }}
      </div>
      <p class="has-text-grey">
        <router-link :to="{ name: 'authSignIn' }">
          {{ $t("auth.signIn") }}
        </router-link>
        &nbsp;·&nbsp;
        <router-link :to="{ name: 'authForgotConfirm' }">
          {{ $t("auth.alreadyCode") }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import { ref, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const router = useRouter();
    const isLoad = ref(false);
    const form = reactive({
      email: store.getters.email,
    });
    const errorMessage = ref();

    const forgotPassword = async () => {
      isLoad.value = true;
      try {
        await Auth.forgotPassword(form.email);
        store.commit("setEmail", form.email);
        router.push({ name: "authForgotConfirm" });
      } catch (e) {
        if (e.code == "UserNotFoundException") {
          errorMessage.value = t("auth.forgotErrorMessage");
        }
      } finally {
        isLoad.value = false;
      }
    };

    return {
      form,
      errorMessage,
      isLoad,
      forgotPassword,
    };
  },
};
</script>
